import { Injectable } from '@angular/core';

import { IUserFolder, UserFolderCategory } from '../types';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})
export class UserApi {
    constructor(private readonly api: Api) { }
    url: any;
    userProperties: string = 'id, email, firstName, lastName';
    publicUserProperties: string = 'id, firstName, lastName';
    userFolderProperties: string = 'applicationId, category, createdDate, displayOrder, id, lastEditedDate, maps, name, parentUserFolderId, userId';

    async getUsers(id: number[], canViewSensitiveData = true) {
        const queryType = canViewSensitiveData ? 'users' : 'publicUsers';
        const userProperties = canViewSensitiveData ? this.userProperties : this.publicUserProperties;

        return await this.api.http2.graphqlRequest(`query GetUsers($id: [Int]) {
                ${queryType}(id: $id){
                    ${userProperties}
                }
            }`, { id }, 'GET', queryType);
    }

    async queryUsers(queryArgs: any, properties?: string) {
        const props = properties ? properties : this.userProperties;
        return await this.api.http2.graphqlRequest(`query queryUsers() {
                users(${queryArgs}){
                     ${props}
                }
            }`, {}, 'GET', 'users');
    }

    async searchUsers(search: string, first?: number, publicData?: boolean) {
        const queryType = publicData ? 'publicUsers' : 'users';
        const columns = ['department', 'id', 'firstName', 'lastName'];

        if (!publicData) {
            columns.push('email');
        }

        if (first) {
            return await this.api.http2.graphqlRequest(`query  {
                ${queryType}(search: "${search}", first: ${first} ){
                    ${columns}
                }
            }`, null , 'GET', queryType);
        } else {
            return await this.api.http2.graphqlRequest(`query {
                ${queryType}(search: "${search}"){
                    ${columns}
                }
            }`, { search }, 'GET', queryType);
        }

    }

    async queryUserFolders(userId: number, appId: number, category?: UserFolderCategory) {
        return await this.api.http2.graphqlRequest<IUserFolder[]>(`query GetUserFolders($userId: [Int], $appId: [Int], $category: [String]) {
            userFolder(applicationId: $appId, userId: $userId, category: $category) {
                id
                name
                parentUserFolderId
                applicationId
                userId,
                category
            }
        }`, { userId, appId, category }, 'GET', 'userFolder');
    }

    async createNewUserFolder(newFolder: IUserFolder) {
        return await this.api.http2.graphqlRequest<IUserFolder>(`mutation CreateNewUserFolder($folder: UserFolderInput!) {
            saveUserFolder(userFolder: $folder) {
                id
                name
                parentUserFolderId
                userId
                applicationId
                category
            }
        }`, {folder: newFolder}, 'POST', 'saveUserFolder');
    }

    async deleteUserFolder(id: number) {
        return await this.api.http2.graphqlRequest(`mutation {
            deleteUserFolder(id: ${id})
        }`, null, 'GET', null);
    }

    // async create(user) {
    //     return await this.api.http2.graphqlRequest(`
    //         mutation CreateUser($user: UserInput!){
    //             createUser(user: $user){
    //                 id
    //             }
    //         }
    //     `, { user: this.sanitize(user) }, 'POST', 'createuser.id');
    // }

    async update(user) {
        return await this.api.http2.graphqlRequest(`
                mutation UpdateUser($user: UserInput!){
                    saveUser(user: $user){
                        email
                    }
                }
            `, { user: this.sanitize(user) }, 'POST', 'saveUser');
    }

    sanitize(user) {
        // only keep layer properties
        const result = this.api.pick(user, this.userProperties.split(', '));
        return result;
    }

    async registerUser(email: string) {
        return await this.api.http2.get('registerUser', { emailAddress: email });
    }

    // async delete(userId: number) {
    //     return await this.http2.graphqlRequest(`
    //         mutation DeleteUser($userId: Int!) {
    //             deleteUser(id: $userId)
    //         }
    //     `, { userId });
    // }
}
